import { Box, TableCell } from "@mui/material";
import StyledTableRow from "../../../components/table/styled-table-row";
import { Plan, PlanRequest } from "../../../service/model/plan.model";
import { useState } from "react";
import PlanForm from "./plan-form";
import { ConfirmationDialog } from "../../../components/confiramation-dialog";
import { useAppDispatch } from "../../../app/hooks";
import { deletePlan, updatePlan } from "../plan.slice";
import TableActionButton from "../../../components/table/table-action-button";
import { EditIcon, DeleteIcon } from "../../../shared/icons";

interface TableRowProps {
    readonly plan: Plan
}

const PlanTableRow: React.FC<TableRowProps> = ({ plan }) => {
    const dispatch = useAppDispatch();
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [showPlanForm, setShowPlanForm] = useState(false);

    const handleDelete = () => {
        dispatch(deletePlan(plan.id))
        setShowDeleteDialog(false)
    }

    const handleDeleteCancel = () => {
        setShowDeleteDialog(false)
    }

    const handleSubmit = (data: PlanRequest) => {
        dispatch(updatePlan({ ...data, id: plan.id }));
        setShowPlanForm(false);
    };

    return (
        <>
            <StyledTableRow key={plan.id}>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">ID</Box>{plan.id}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Name</Box>{plan.name}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Price</Box>{plan.price}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Message Limit</Box>{plan.messageLimit}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Account Limit</Box>{plan.userAccountLimit}</TableCell>
                <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Product Limit</Box>{plan.storeProductLimit}</TableCell>
                {/* <TableCell><Box component="div" display="inline" className="responsive-mobile-heading">Expiry</Box>{node.branch.createdDate}</TableCell> */}
                <TableCell>
                    <Box component="div" display="inline" className="responsive-mobile-heading">Actions</Box>
                    {/* <IconButton onClick={() => setShowPlanForm(true)} sx={{color: `${theme.palette.secondary.main}`, paddingLeft: 0}}><VisibilityIcon /></IconButton> */}
                    <TableActionButton onClick={() => setShowPlanForm(true)} label="Edit" icon={<EditIcon />} />
                    <TableActionButton onClick={() => setShowDeleteDialog(true)} label="Delete" icon={<DeleteIcon />} />
                    {/* <Link className="btn" to="#" data-toggle="modal" data-target="#delete-member-modal" onClick={() => setShowDeleteDialog(true)}><DeleteIcon /></Link> */}
                </TableCell>
            </StyledTableRow>
            {showPlanForm &&
                <PlanForm plan={plan} editable={true} onClose={() => setShowPlanForm(false)} onSubmit={handleSubmit} />
            }
            {showDeleteDialog &&
                <ConfirmationDialog show={true} message={<>Are you sure you want to delete plan <strong>{plan.name}</strong>?</>} onConfirm={handleDelete} onCancel={handleDeleteCancel} />
            }
        </>
    );
}

export default PlanTableRow;